let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eW6id")).then(() => parcelRequire('f9hBa'));